import * as z from 'zod';

import { pickTicketsQuerySchema } from './pick-tickets-query-schema';

export const pickTicketsMutationSchema = pickTicketsQuerySchema
  .omit({
    client: true,
    pick_ticket_items: true,
    picked_at: true,
  })
  .extend({
    delivery_address: z.array(z.number()),
    attached_documents: z.array(z.number()),
    contacts: z.array(z.number()),
  });

export type PickTicketsMutationSchema = z.infer<typeof pickTicketsMutationSchema>;

export const pickTicketsCreateSchema = pickTicketsMutationSchema.omit({
  id: true,
});

export type PickTicketsCreateSchema = z.infer<typeof pickTicketsCreateSchema>;
